import React from 'react';
import { useTranslation } from 'react-i18next';
import LandingHeader from '../molecules/LandingHeader/LandingHeader.component';
import LandingFooter from '../molecules/LandingFooter/LandingFooter.component';
import { DemoDialogProvider } from '../molecules/DemoDialog/DemoDialog.context';
import { Main, SkipLink } from './Layout.styled';

interface IProps {
  children: React.ReactNode;
}

const Layout = ({ children }: IProps) => {
  const { t } = useTranslation();

  return (
    <DemoDialogProvider>
      <SkipLink href="#main">{t('landing.skip')}</SkipLink>
      <LandingHeader />
      <Main id="main">{children}</Main>
      <LandingFooter />
    </DemoDialogProvider>
  );
};

export default Layout;
